export default {
    namespaced: true,
    state: {
        isLoggedIn: false
    },
    mutations: {
        login: (state) => {
            state.isLoggedIn = true;
        },
        logout: (state) => {
            state.isLoggedIn = false;
        }
    },
    actions: {

        doLogin(context, credentials) {
            return this.$axios.post('/auth/login', {'username': credentials.username, 'password': credentials.password})
                .then(response => {
                    if(response.data.access_token) {
                        context.dispatch('user/doAuthUser', response, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.dispatch('profiles/resetTmpProfile', {}, {root: true});
                        context.commit('login');
                    }

                    return response;
                });
        },

        doFBLogin(context, token) {
            return this.$axios.get('/auth/fb-login/' + token)
                .then(response => {
                    if(response.data.access_token) {
                        context.dispatch('user/doAuthUser', response, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.dispatch('profiles/resetTmpProfile', {}, {root: true});
                        context.commit('login');
                    }
                    else {
                    }

                    return response;
                });
        },

        doGoogleLogin(context, token) {
            return this.$axios.get('/auth/google-login/' + token)
                .then(response => {
                    if(response.data.access_token) {
                        context.dispatch('user/doAuthUser', response, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.dispatch('profiles/resetTmpProfile', {}, {root: true});
                        context.commit('login');
                    }
                    else {
                    }

                    return response;
                });
        },

        doAppleLogin(context, token) {
            return this.$axios.get('/auth/apple-login/' + token)
                .then(response => {
                    if(response.data.access_token) {
                        context.dispatch('user/doAuthUser', response, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.dispatch('profiles/resetTmpProfile', {}, {root: true});
                        context.commit('login');
                    }
                    else {
                    }

                    return response;
                });
        },

        doLogout(context, withoutRequest = false) {

            if(!withoutRequest) {
                return this.$axios.post('/auth/logout')
                    .then(response => {
                        context.dispatch('user/doLogoutUser', {}, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.dispatch('profiles/resetProfiles', {}, {root: true});
                        context.commit('logout');
                        return response;
                    });
            }
            else {
                context.dispatch('user/doLogoutUser', {}, {root: true});
                context.dispatch('profiles/resetProfiles', {}, {root: true});
                context.commit('logout');
            }
        },

        logWithUser(context, params) {
            return this.$axios.get('/auth/log_by_force/' + params.id + '/' + params.hash)
                .then(response => {
                    if(response.data.access_token) {
                        context.dispatch('user/doAuthUser', response, {root: true});
                        context.dispatch('cart/setProfileId', 0, {root: true});
                        context.commit('login');
                    }

                    return response;
                });
        }
    },
    getters: {
        getLoginStatus: (state) => {
            return state.isLoggedIn;
        }
    }
}
